export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6296.dc17a89c.jpg";